/**
 * When Apple sign-in is offered (native iOS or Safari web): Apple primary, Google as a text link for existing Google users.
 * Otherwise: Sign in with Google only (with logo).
 */
export const AuthSignInButtons = ({
  acceptedTerms,
  isSigningIn,
  canShowAppleAuth,
  onGoogle,
  onApple,
  GoogleLogo,
  AppleLogo,
}) => {
  const disabled = isSigningIn || !acceptedTerms;
  const primaryClass =
    'w-full rounded-full px-4 py-3 bg-theme-primary text-primary font-body text-sm inline-flex items-center justify-center gap-2';
  const linkClass =
    'w-full mt-1 py-2 text-center font-body text-sm text-secondary underline disabled:opacity-50';

  if (canShowAppleAuth) {
    return (
      <div className="space-y-1">
        <button type="button" onClick={onApple} disabled={disabled} className={primaryClass}>
          <AppleLogo className="h-4 w-4" />
          {isSigningIn ? 'Opening sign-in...' : 'Sign in with Apple'}
        </button>
        <button type="button" onClick={onGoogle} disabled={disabled} className={linkClass}>
          Existing Google Users Only
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <button type="button" onClick={onGoogle} disabled={disabled} className={primaryClass}>
        <GoogleLogo className="h-4 w-4" />
        {isSigningIn ? 'Opening sign-in...' : 'Sign in with Google'}
      </button>
    </div>
  );
};
